import '../style/global.css';

import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import { useHistory, useLocation } from 'react-router-dom';
import { UserApi } from "../api/UserApi";
import background from '../asset/background-login.png';
import { handleErrorMessage } from '../component/ErrorDialog';
import AppBarContext from '../context/AppBarContext';

export default function TopReferrer() {

    const { setErrorMessage } = React.useContext(AppBarContext)
    const history = useHistory();
    const location = useLocation();

    const [referrerList, setReferrerList] = React.useState<[]>([]);

    React.useEffect(() => {
        UserApi.getReferrerList()
            .then(response => {
                if (response.status < 300) {
                    return response.data;
                }
                throw new Error("Unable to UserApi.getReferrerList() " + response.status)
            })
            .then(list => setReferrerList(list))
            .catch(err => {
                handleErrorMessage(err, setErrorMessage, history, location);
            })
    }, [history, location, setErrorMessage]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'calc(100vh - 85px)',
            width: '100%',
            padding: 0,
            backgroundImage: `url(${background})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }}>
            <Typography variant="h4">We need your help getting the word out!</Typography>
            <Typography variant="h5" sx={{ mt: 2 }}>
                If you find this site useful, <span style={{ color: '#E6B800 ', fontWeight: 'bold' }}>share your pronunciation score</span> from the Pronunciation page (Share button after you record). When someone opens your link and later registers, it counts as your referral.
            </Typography>
            <Typography variant="h5" sx={{ mt: 2 }}>
                If this site takes off, the top 10 referrers will recieve a free 5 year, 10 year or maybe lifetime subscription.
            </Typography>
            <Typography variant="h5">
                Additional rewards beyond the top 10 are likely.
            </Typography>
            <Box
                sx={{
                    mt: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    maxHeight: 'calc(100vh - 300px)',
                    width: '60%',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '16px',
                    overflowY: 'auto',
                    border: '1.5px solid rgba(82, 99, 125, 0.2)',
                }}
            >
                <TableContainer sx={{ overflowX: 'auto', p: 2, my: 4 }}>
                    <Table aria-label="simple table" sx={{ minWidth: 650, border: 1, borderColor: 'rgba(224, 224, 224, 1)', margin: 'auto', width: 'auto' }}>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row" sx={{ py: 1, borderTopLeftRadius: '16px' }} align="left">
                                    <Typography variant="h4">First Name</Typography>
                                </TableCell>
                                <TableCell component="th" scope="row" sx={{ py: 1, borderTopLeftRadius: '16px' }} align="center">
                                    <Typography variant="h4">Referral Count</Typography>
                                </TableCell>
                            </TableRow>
                            {referrerList.map((referrer, index) => (
                                <TableRow key={index}>
                                    <TableCell align="left" sx={{
                                        py: 1,
                                    }}>
                                        {referrer['first_name']}
                                    </TableCell>
                                    <TableCell align="center" sx={{
                                        py: 1,
                                    }}>
                                        {referrer['ref_count']}
                                    </TableCell>
                                </TableRow>
                            ))}

                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </div>
    );
}
